import React, { useState, useRef } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
} from '@mui/material';
import { VolumeUp } from '@mui/icons-material';

import { useDispatch, useSelector } from 'react-redux';
import { Nextstep } from './features/counterSlice';
import { AnswerResult, NoanswerResult } from './features/resultSlice';
import ReactPlayer from 'react-player';
import { Snackbar, Alert } from '@mui/material';

function ListeningTest() {
    const apiData = useSelector((state) => state.questionResult.apiData);
    console.log('listing', apiData);
    const [data, setdata] = useState(apiData.data);
    const dispatch = useDispatch();
    const [playing, setPlaying] = useState(false); // Audio play state
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const TOTAL_LISTEN = apiData?.data?.Listen_Que?.Total || 0;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedOption, setSelectedOption] = useState(null);

    const audioRef = useRef(null); // Reference for audio playback
    const currentQuestion = apiData.data.Listen_Que[currentIndex] || {};
    const Qcategory = currentQuestion.category || 'Radio';  // Default category is 'General'
    const Answer = currentQuestion.Answer || 'No Answer Available';
     

    const handleNext = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
       
        if (selectedOption == null) {
            setOpen(true);
            setMessage('Please enter your answer before proceeding!');
 
            return;
        }
        if (Answer == selectedOption) {
             dispatch(AnswerResult({ testIndex: 0 }));
        } else if (Answer != selectedOption) {
            dispatch(NoanswerResult({ testIndex: 0 }));
        }
        setSelectedOption(null); // Reset selected option for the next question
        setPlaying(false); // Stop audio

         console.log('Next bk,utton clicked, current index:',currentIndex, data.Listen_Que.length);
        setCurrentIndex((prevIndex) => {
            const newIndex = prevIndex < TOTAL_LISTEN - 1 ? prevIndex + 1 : prevIndex;
            if (currentIndex === TOTAL_LISTEN - 1) {
               dispatch(Nextstep());

            }

            return newIndex;
        });
    };

    const handleSpeak = (audioFileName) => {
        // Stop currently playing audio if it exists
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }

        // Create and play new audio
        const audio = new Audio(audioFileName);
        audioRef.current = audio; // Save reference to the audio
        audio.play();
    };

    return (
        <Box sx={{ maxWidth: 800, margin: 'auto', p: 2, textAlign: 'center' }}>
            {/* Header */}
            <Box sx={{ marginTop: 3 }}>
                <Typography
                    variant="body1"
                    sx={{ fontSize: '1.1rem', marginBottom: 1, textAlign: 'left' }}
                >
                    {currentQuestion.description}
                </Typography>
                <Box
                    display="flex"
                    alignItems="center"
                    sx={{
                        gap: 1,
                        padding: 2,
                        backgroundColor: '#fff',
                        borderRadius: '10px',
                        boxShadow: 3,
                    }}
                >

                    {currentQuestion.qtype === 'AudioQuestions' && (
                        <ReactPlayer
                            src={currentQuestion.Audio_file}

                            playing={playing}
                            controls
                            height="50px"
                            width="100%"
                            onPlay={() => setPlaying(true)}
                            onPause={() => setPlaying(false)}
                            onEnded={() => setPlaying(false)}
                            style={{
                                backgroundColor: "#FFF"
                            }}
                        />
                    )}



                    {currentQuestion.qtype === 'TextQuestions' && (
                        <Box
                            display="flex"
                            alignItems="center"
                            sx={{
                                gap: 1,
                                padding: 2,
                                backgroundColor: '#fff',
                                borderRadius: '10px',
                                boxShadow: 3,
                            }}
                        >
                            TextQuestions

                        </Box>
                    )}

                </Box>

            </Box>


            {Qcategory === 'Image' && (



                <Box sx={{ marginTop: 3, display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-around' }}>
                    <RadioGroup
                        row
                        value={selectedOption}
                        onChange={(e) => setSelectedOption(e.target.value)}
                        sx={{ width: '100%', justifyContent: 'space-around', flexWrap: 'nowrap', }}
                    >
                        {currentQuestion.Options.map((option, index) => (

                            <FormControlLabel
                                key={index}
                                value={option.value}
                                control={
                                    <Radio
                                        color="primary"
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            zIndex: 1,
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ textAlign: 'center', maxWidth: '230px' }}>
                                        <img
                                            src={option.Image}
                                            alt={option.label}
                                            style={{ width: '100%' }}
                                        />
                                    </Box>
                                }
                                sx={{
                                    position: 'relative',
                                    display: 'inline-block',
                                }}
                            />
                        ))}
                    </RadioGroup>
                </Box>
            )}

            {Qcategory === 'Radio' && (
                <Box
                    sx={{
                        marginTop: 2,
                        padding: 2,
                        textAlign: 'left',
                        backgroundColor: '#fff',
                        borderRadius: '4px',
                        boxShadow: 3,
                    }}
                >
                    <FormControl component="fieldset">
                        <RadioGroup
                            aria-label={`question${currentIndex + 1}`}
                            name={`question${currentIndex + 1}`}
                            sx={{ marginTop: 1 }}
                        >
                            {currentQuestion.Options.map((option, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={option.value}
                                    control={<Radio color="primary" />}
                                    label={option.label}
                                    onChange={(e) => setSelectedOption(e.target.value)}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Box>
            )}

            {/* Next Button */}
            <Box mt={3}>
                <Button onClick={handleNext} sx={{ padding: '10px 40px' }}>
                    <img
                        src="/images/Picture7.png"
                        alt="Next"
                        style={{ width: '150px', height: 'auto' }}
                    />
                </Button>
                <Snackbar
                    open={open}
                    autoHideDuration={5000}
                    onClose={() => setOpen(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={() => setOpen(false)} severity="warning" sx={{ width: '100%' }}>
                        {message}
                    </Alert>
                </Snackbar>

            </Box>
        </Box>
    );
}

export default ListeningTest;
